module.exports = __webpack_public_path__ + "static/img/10.ff379482.jpeg";